export const maskValue = (value: string | number | Date): string => {
  if (value === null || value === undefined) return '';

  const strValue =
    value instanceof Date ? value.toISOString() : String(value);
  if (strValue.includes('@')) {
    const [name, domainFull] = strValue.split('@');
    const [domain, tld = ''] = domainFull?.split('.') || ['', ''];

    const maskPart = (part: string) => {
      if (part.length <= 1) return part;
      const firstChar = part.charAt(0);
      const maskedRest = '*'.repeat(part.length - 1);
      return firstChar + maskedRest;
    };

    return `${maskPart(name)}@${maskPart(domain)}.${maskPart(tld)}`;
  }
  const isNumeric = !isNaN(Number(strValue)) && strValue.trim() !== '';
  if (isNumeric) {
    if (strValue.length <= 2) return strValue;
    const firstTwo = strValue.slice(0, 2);
    const maskedRest = '*'.repeat((strValue.length - 2) * 2);
    return firstTwo + maskedRest;
  }
  const datePattern = /^\d{1,2}\s[A-Za-z]{3},\s\d{4}$/;
  const isIsoDate = /^\d{4}-\d{2}-\d{2}T/.test(strValue);
  if (datePattern.test(strValue) || isIsoDate) {
    return '*'.repeat(strValue.length);
  }

  if (strValue.length <= 2) return strValue;
  const firstTwo = strValue.slice(0, 2);
  const maskedRest = '*'.repeat((strValue.length - 2) * 2);
  return firstTwo + maskedRest;
};